import React from 'react';
import styled from 'styled-components';
import JumpLink from '../../components/JumpLink';
import { DisclaimerLink } from '../../components/Disclaimer';
import { formatDollars } from '../../pages/calculator/utils';

const UseTheCalculator = styled(JumpLink)`
  font-weight: bold;
  color: ${(props) => props.theme.colors.gradientLight};
`;

const CompetitorPriceCell = ({ maxPrice }: { maxPrice: number }) => {
  return maxPrice > 0 ? (
    <div>
      Up to {formatDollars(Math.round(maxPrice * 24), 0)} in upfront costs<DisclaimerLink>2</DisclaimerLink>
    </div>
  ) : (
    <UseTheCalculator href="#val-calc-section">Use the calculator to find out</UseTheCalculator>
  );
};

export default CompetitorPriceCell;



// WEBPACK FOOTER //
// ./packages/smart-home-support/assets/components/CalculatorCompetitorPriceCell.tsx